<template>
  <v-container v-if="component != null" class="subsection">
    <SubSectionFactory :component="component" :variant_color="variant_color" />
  </v-container>
</template>

<script>
import SubSectionFactory from "./FactorySubSection";

export default {
  name: "SubSection",
  components: { SubSectionFactory },
  props: {
    index: {
      type: Number,
      default: 0
    },
    component: {
      type: Object,
      default: null
    },
    variant_color: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
.subsection {
  background-color: transparent;
}

.subsection-title {
  width: 70%;
  text-align: center;
  font-weight: 600 !important;
  font-size: 38px !important;
  line-height: 46px;
  font-style: normal;
}

.subsection-subtitle {
  width: 25em;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
}
</style>
